// DRF emits field errors as `string[]` from serializer validation but as a bare `string` from view-level
// `ValidationError({"key": "msg"})` raises (which bypass `as_serializer_error`). Normalize to a list either way.
export default function getApiErrorMessages(value: string[] | string | undefined): string[] {
    if (Array.isArray(value)) {
        return value
    } else if (typeof value === "string") {
        return [value]
    } else {
        return []
    }
}
